import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

const modifyEvent = async (
  membersid,
  start,
  end,
  date,
  packname,
  pack_id,
  link,
  mandataireauto,
  nomauto,
  titreauto,
  titre,
  selectedClientId, // assuming client is passed as an ID
  emails,
  numparticulier,
  msgcontent,
  name,
  address,
  ville,
  postal,
  description,
  folder_id, // assuming folder is passed as an ID
  conductor_id,
  eventref_id, // assuming eventRef is passed as an ID
  documents_completed,
  rdv_confirmed,
  selected_event_type,
  event_frequency,
  exception_dates,
  token,
  prefix,
  cancelled = false
) => {
  // Define the endpoint URL for your Python backend
  const url = prefix + `events/${eventref_id}`;

  // Define the request body
  const body = {
    members_id: membersid,
    name: name,
    description: description,
    start: start,
    end: end,
    date: date,
    pack_name: packname,
    pack_id: pack_id,
    link: link,
    mandataire_auto: mandataireauto,
    nom_auto: nomauto,
    titre_auto: titreauto,
    titre: titre,
    selected_client_id: selectedClientId,
    emails: emails,
    num_particulier: numparticulier,
    msg_content: msgcontent,
    address: address,
    ville: ville,
    postal: postal,
    folder_id: folder_id,
    conductor_id: conductor_id,
    documents_completed: documents_completed,
    rdv_confirmed: rdv_confirmed,
    cancelled: cancelled,
    selected_event_type: selected_event_type,
    event_frequency: event_frequency,
    exception_dates: exception_dates,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Make the PUT request to modify the event
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    let responseData = await response.json();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      eventref_id, // event reference ID
      "", // docid (optional)
      JSON.stringify(body), // request body as string
      JSON.stringify(responseData), // response data as string
      "PUT",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      return responseData;
    } else {
      console.error(`Failed to modify event: ${response.status}`);
      return `Failed to modify event: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default modifyEvent;
